import GrammarCongratsPage from './GrammarCongratsPage'

export default GrammarCongratsPage
